import { createFileRoute, Navigate } from '@tanstack/react-router'
import { getSettingsLandingPath } from '@/components/layout/settings-route-access'
import { useStaffPermissionAccess } from '@/hooks/use-staff-permission-access'
import { useOrg } from '@/providers'

export const Route = createFileRoute('/_auth/$orgId/settings/')({
  component: SettingsPage,
})

/** The Settings link opens the first settings page this person may manage (the access boundary refuses otherwise). */
function SettingsPage() {
  const { shortCode } = useOrg()
  const landing = getSettingsLandingPath(useStaffPermissionAccess())
  if (!landing) return null
  return <Navigate to={`/$orgId/${landing}`} params={{ orgId: shortCode }} replace />
}
